import { useEffect } from "react";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { recoilPersist } from "recoil-persist";

// 화면 언어. 헤더에서 바꾸고, 새로고침해도 유지된다 (localStorage "atlas-lang")
export type Lang = "ko" | "en";

const { persistAtom } = recoilPersist({ key: "atlas-lang" });

export const langAtom = atom<Lang>({
  key: "lang",
  default: "ko",
  effects_UNSTABLE: [persistAtom],
});

export const useLang = () => useRecoilValue(langAtom);
export const useLangState = () => useRecoilState(langAtom);

// 언어별 문구 묶음에서 현재 언어의 것을 고른다.
// 사용법: const ko = {...}; const en: typeof ko = {...}; → useMessages({ ko, en })
// (en 을 typeof ko 로 선언해 두면 빠진 문구가 있을 때 타입 오류가 난다)
export const useMessages = <T>(messages: Record<Lang, T>): T => messages[useLang()];

// <html lang> 을 현재 언어에 맞춘다 (스크린리더, 브라우저 번역 제안 등)
export const useSyncHtmlLang = () => {
  const lang = useLang();
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
};
